import { render, staticRenderFns } from "./EtapaDadosEmpresa.vue?vue&type=template&id=2c4c6691"
import script from "./EtapaDadosEmpresa.vue?vue&type=script&lang=js"
export * from "./EtapaDadosEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports